import { Component } from '@angular/core';

@Component({
  selector: 'de-report-issues',
  templateUrl: './report-issues.component.html',
  styleUrls: ['./report-issues.component.scss'],
})
export class ReportIssuesComponent {
}
